module.exports = __webpack_public_path__ + "img/dsci0104.9342142d.jpg";